import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var pageNo = 0;
var notifi_arr = [];
class NotificationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpened : false
        };
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.notificationData.message !== this.props.notificationData.message){
            if(nextProps.notificationData.statusCode == 400){
                swal(nextProps.notificationData.message)
            }
        }
    }
    getNotificationList =() => {
        pageNo = 1;
        notifi_arr = [];
        this.setState({isOpened: !this.state.isOpened});
        let requestPayload = {
            "UserCategoryId": 3,
            "PageNo": pageNo
        }
        sleep(1000).then(() => {
            if(this.state.isOpened){
                this.props.notificationList(requestPayload);
            }
        })
    }
    changeNotificationReadStatus =(item) =>{
        let requestPayload = {
            "UserCategoryId" : 3,
            "ID" : item.ID
        }
        this.props.readNotification(requestPayload);

        sleep(1000).then(() =>{
            if(item.Event == 'DEVICE REGISTER'){
                this.props.history.push('/superadmin/pendingFirstResponder');
            }
            if(item.Event == 'UPDATE USER PROFILE'){
                this.props.history.push('/superadmin/FirstResponder');
            }
            this.setState({isOpened: !this.state.isOpened});
        })
    }
    loadMore = () => {
        pageNo = pageNo + 1;
        let requestPayload = {
            "UserCategoryId": 3,
            "PageNo": pageNo
        }
        this.props.notificationList(requestPayload);
    }
    render() {
        const { t } = this.props;
        this.props.notificationData.notificationList.forEach(item =>{
            if(item.ID){
                notifi_arr.push(item);
            }
        })
        // console.log("notifi_arr",notifi_arr);
        return (
            <div>
                <ul className="nofitications-dropdown" >
                    <li className="dropdown head-dpdn">
                        <span
                            className="dropdown-toggle notificationbell"
                            data-toggle=""
                            aria-expanded="false"
                            onClick={this.getNotificationList}
                        >
                            <i className="fa fa-bell" ></i>
                            {
                                (this.props.notificationData.count > 0) ?
                                    <span className="badge blue">{this.props.notificationData.count}</span>
                                    : ''
                            }
                        </span>
                        <ul className={this.state.isOpened ? 'dropdown-menu anti-dropdown-menu agile-notification show-notifi-list' : 'dropdown-menu anti-dropdown-menu agile-notification'} >
                            <li>
                                <div className="notification_header">
                                    {
                                        (this.props.notificationData.count > 0) ?
                                            <h3>{t('Notif.You have')} {this.props.notificationData.count} {t('Notif.new notifications')}</h3>

                                            : <h3></h3>

                                    }
                                </div>
                            </li>
                            {
                                notifi_arr.map((item, index) =>
                                    <li key={index} className={item.ReadNotification==false ? 'un-read-notifi' : ''}>
                                        <a href="#"
                                            onClick={(e) => this.changeNotificationReadStatus(item, e, this)}
                                        >
                                            <div className="notification_desc">
                                                <p>{item.Event}</p>
                                                <p><span>{item.Description}</span></p>
                                            </div>
                                            <div className="clearfix"></div>
                                        </a>
                                    </li>

                                )
                            }
                            <p className="load-more" onClick={this.loadMore}>{t('Notif.Load More')}...</p>


                        </ul>
                    </li>

                    <div className="clearfix"> </div>
                </ul>
            </div>
        );
    }
}
export default withNamespaces()(withRouter(NotificationComponent));